<template>
  <sFormItem
    class="comparation"
    prop="mutableValue"
    :rules="comparationRules">
    <sSelect
      class="width-100"
      clearable
      data-qa="condition-operator"
      :disabled="disabled"
      :placeholder="$t('Tenders.Comparison')"
      :value.sync="mutableValue">
      <sOption
        v-for="operator in operators"
        :key="operator"
        data-qa="operator"
        :disabled="disabled"
        :label="$t(`Automation.operator.${operator}`)"
        :value="operator"/>
    </sSelect>
  </sFormItem>
</template>
<script>
export default {
  name: 'operator',
  data() {
    const that = this
    return {
      comparationRules: {
        required: true,
        trigger: 'change',
        validator(rule, value, callback) {
          if (!that.mutableValue) {
            callback(new Error(that.$t('Validate.Required')))
          }
          callback()
        },
      },
    }
  },
  computed: {
    mutableValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('update:value', newValue)
      }
    }
  },
  props: {
    value: {
      type: String
    },
    operators: {
      type: Array
    },
    disabled: {
      type: Boolean
    }
  },
}
</script>
